import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const otpApiConfig = {
  /* -------------------------------------------------------------------------- */
  /*                               FETCH OPERATIONS                             */
  /* -------------------------------------------------------------------------- */

  verifyToken: {
    key: "verifyToken",
    url: "/api/v1/otp/verify",
    method: "POST",
    options: {
      ...QUERY_PRESETS.MUTATION,
      retry: 1,
      meta: { description: "Verify OTP token for registration" },
    },
  },
  sendOtp: {
    key: "sendOtp",
    url: "/api/v1/otp/send",
    method: "POST",
    options: {
      ...QUERY_PRESETS.MUTATION,
      retry: 1,
      meta: { description: "Send OTP token for registration" },
    },
  },
};

